import type { Command, SimState } from './domain/model';
import type { CreditTransaction, Player } from './domain/player';

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
  ) {
    super(message);
  }
}

export async function request<T>(path: string, body?: unknown): Promise<T> {
  const response = await fetch(
    `/api/${path}`,
    body !== undefined
      ? {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      : undefined,
  );
  const result = await response.json().catch(() => ({}));
  if (!response.ok) throw new ApiError(result.error || 'Anfrage fehlgeschlagen.', response.status);
  return result;
}
export const command = (input: Command) =>
  request<{ state: SimState; player: Player; transaction?: CreditTransaction }>('commands', input);
